class ClearingValidationController {
    constructor($window, $routeParams, $location, toastr, ngProgressFactory, moment, Upload, ClearingBatchServiceApi, SettingsExService, ClearingServiceApi, UtpUserTestSuitesServiceApi) {
        this.$onInit = () => {
            this.init();
        };
        this.init = () => {
            this.ngProgress = this.ngProgressFactory.createInstance();
            this.state = {
                userId: 0,
                simId: 0,
                clearingSimId: 0,
                appSettings: undefined,
                selectedBatch: undefined,
                selectedTestSuite: undefined,
                searchLoading: false,
                clearingValidationRequestLoading: false,
                selectedUploadFile: undefined,
                selectedBatchTestSuiteTracesCount: undefined,
                fileType: 'clearing'
            };
            this.data = {
                batches: [],
                testSuites: []
            };
            this.state.userId = parseInt(this.$routeParams.userId, 10);
            this.state.simId = parseInt(this.$routeParams.simId, 10);
            if (!_.isNumber(this.state.userId) || !_.isNumber(this.state.simId)) {
                this.toastr.error('Problem getting user ID and/or simulator ID');
                return;
            }
            this.state.clearingValidationRequestLoading = true;
            this.state.searchLoading = true;
            this.ClearingServiceApi.getClearingSim(this.state.userId, this.state.simId)
                .then((response) => {
                let simLink = response.data;
                if (!simLink) {
                    this.toastr.error('Simulator is not linked with clearing simulator');
                }
                else {
                    this.state.clearingSimId = simLink.PrimarySimulatorId;
                }
                this.state.clearingValidationRequestLoading = false;
            }, () => { this.state.clearingValidationRequestLoading = false; });
            this.getAppSettings().then(() => {
                return this.getBatches();
            }).then(() => {
                return this.getTestSuites();
            }).then(() => {
                this.state.searchLoading = false;
            });
        };
        this.getAppSettings = () => {
            return this.SettingsExService.getSettings().then((response) => {
                this.state.appSettings = response.data;
            });
        };
        this.getBatches = () => {
            return this.ClearingBatchServiceApi.getAllBatches(this.state.userId, this.state.simId)
                .then((response) => {
                this.data.batches = _.filter(response.data, (cb) => {
                    // We only want the completed ones
                    return !_.isNil(cb.EndDate);
                });
            });
        };
        this.getTestSuites = () => {
            return this.UtpUserTestSuitesServiceApi.testSuites(this.state.userId, this.state.simId)
                .then((response) => {
                this.data.testSuites = response.data;
            });
        };
        this.onTestSuiteSelect = (selectedTestSuite) => {
            this.resetSelectedDetails();
            return this.ClearingBatchServiceApi.getMessageTraceCountForBatch(this.state.userId, this.state.simId, this.state.selectedBatch.Id, selectedTestSuite.Id)
                .then((response) => {
                this.state.selectedBatchTestSuiteTracesCount = response.data;
            });
        };
        this.toFormattedDateTime = (dateTime) => {
            if (_.isNil(dateTime)) {
                return '';
            }
            return this.moment.utc(dateTime).format(this.state.appSettings.DateTimeFormat);
        };
        this.submitClearingValidationRequest = (file) => {
            return this.Upload.upload({
                method: 'post',
                params: {
                    userId: this.state.userId,
                    simulatorId: this.state.simId,
                    clearingBatchId: this.state.selectedBatch.Id,
                    testSuiteId: this.state.selectedTestSuite.Id
                },
                url: 'api/Clearing',
                data: { File: file }
            }).then((response) => {
                if (response.data.errors.length === 0) {
                    this.toastr.info('Clearing validation request submitted');
                    return true;
                }
                else {
                    for (let error of response.data.errors) {
                        this.toastr.error(error);
                    }
                    return false;
                }
            });
        };
        this.uploadClearingFile = () => {
            this.state.searchLoading = true;
            this.submitClearingValidationRequest(this.state.selectedUploadFile).then((submitSuccess) => {
                this.state.searchLoading = false;
                // Reset the UI on successful submit
                if (submitSuccess) {
                    this.resetAll();
                }
            });
        };
        this.resetAll = () => {
            this.state.selectedBatch = undefined;
            this.resetTestSuite();
        };
        this.resetTestSuite = () => {
            this.state.selectedTestSuite = undefined;
            this.resetSelectedDetails();
        };
        this.resetSelectedDetails = () => {
            this.state.selectedBatchTestSuiteTracesCount = undefined;
            this.state.selectedUploadFile = undefined;
        };
        this.$window = $window;
        this.$routeParams = $routeParams;
        this.$location = $location;
        this.toastr = toastr;
        this.ngProgressFactory = ngProgressFactory;
        this.moment = moment;
        this.Upload = Upload;
        this.ClearingBatchServiceApi = ClearingBatchServiceApi;
        this.SettingsExService = SettingsExService;
        this.UtpUserTestSuitesServiceApi = UtpUserTestSuitesServiceApi;
        this.ClearingServiceApi = ClearingServiceApi;
    }
}
angular.module('app').component('clearingValidation', {
    bindings: {},
    templateUrl: 'scripts/app/partials/ClearingValidation/clearing-validation.tpl.html',
    controllerAs: 'vm',
    controller: ClearingValidationController
});
